import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { catchError, Observable, throwError } from "rxjs";
import { SnackbarService } from "./snackbar.service";

@Injectable()

export class HttpErrorInterceptorService implements HttpInterceptor{
    private snackBar=inject(SnackbarService);
        intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
            return next.handle(request).pipe(
                catchError((error: HttpErrorResponse) => {
                    let errorMessage = 'An unexpected error occurred';
        
                    if (error.error instanceof ErrorEvent) {
                        // Client-side error
                        errorMessage = `Error: ${error.error.message}`;
                    } else {
                        // Server-side error with different possible structures
                        if (typeof error.error === 'string') {
                            errorMessage = error.error;
                        } else if (error.error?.errors && Array.isArray(error.error.errors) && error.error.errors[0]?.message) {
                            // First error structure type
                            errorMessage = error.error.errors[0].message;
                        } else if (error.error?.message) {
                            // Second error structure type
                            errorMessage = error.error.message;
                        }
                    }
                    this.snackBar.error(errorMessage);
                    return throwError(() => error);
                })
            );
        }
        
        
}